<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">P/O変更・取消詳細</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
        <v-btn
          @click="cancelPo"
          v-if="$route.query.poStatus==='CANCEL'"
          v-permit.SHARP_PCD_PO_CANCEL
        >PO取消</v-btn>
        <v-btn
          @click="changePo"
          v-if="$route.query.poStatus==='CONFLICT'"
          v-permit.SHARP_PCD_PO_CHANGE
        >PO变更</v-btn>
      </v-card-actions>
    </v-card>
    <po-list :id="$route.query.conflictId" @conflict="onConflict" class="mt-2" />
    <inv-package-list
      :conflictId="$route.query.conflictId"
      :normalId="$route.query.normalId"
      class="mt-2"
      ref="invPackageList"
    />
    <sa-package-list :id="$route.query.normalId" class="mt-2" ref="saPackageList" />
    <do-package-list :id="$route.query.normalId" class="mt-2" ref="doPackageList" />
  </v-container>
</template>
<script>
import PoList from './PoList'
import InvPackageList from './InvPackageList'
import SaPackageList from './SaPackageList'
import DoPackageList from './DoPackageList'
export default {
  components: {
    PoList,
    InvPackageList,
    SaPackageList,
    DoPackageList
  },
  data() {
    return {
      form: {},
      headers: [],
      results: [],
      selected: [],
      conflictType: 'UNKNOWN',
      conflictFields: [],
      loading: false,
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    onConflict(fields, newUnitPrice) {
      this.$refs.invPackageList.conflict(
        this.$route.query.poStatus,
        fields,
        newUnitPrice
      )
      this.$refs.saPackageList.conflict(
        this.$route.query.poStatus,
        fields,
        newUnitPrice
      )
      this.$refs.doPackageList.conflict(
        this.$route.query.poStatus,
        fields,
        newUnitPrice
      )
    },
    cancelPo() {
      this.$refs.invPackageList.cancel()
    },
    changePo() {
      this.$refs.invPackageList.save()
    }
  }
}
</script>

